var nurseslounge_lounges_tour = {
    init:function($params){
        var $steps = [];
        if($params.profile_id == 1 || $params.profile_id == 2){
            //Non Nurses
            $steps = [
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-dashboard-tour");
                    },
                    title: "Let's Tour Your New Dashboard",
                    content: "We’ll quickly show you around your dashboard and Nurses Lounge features.",
                    //orphan: true
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-bulletin-board-tour");
                    },
                    title: "My Bulletin Board",
                    content: "Announcements for jobs, events, hiring bonuses and other content will be shared with nurses on their bulletin boards. You must own your organization's Lounge page to create content to share with nurses.",
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-profile-tour");
                    },
                    title: "Resume Builder",
                    content: "Add your skills and education to preview and download a .PDF resume. ",
                    onNext: function() {
                        $(".nav-scroller-right-tour").click();
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-articles-tour");
                    },
                    title: "My Articles",
                    content: "Add articles written by nurse leaders affiliated with your organization. Tag your organization to the article to increase attention, views and reach!",
                    onPrev: function () {
                        $(".nav-scroller-left-tour").click();
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".manage-my-lounges-tour");
                    },
                    title: "Manage a Lounge",
                    content: "Search for your organization’s Lounge page to become an owner. Once you are an owner you can add jobs, degrees, events and other content that we will send to nurse dashboards.",
                    onNext: function() {
                        $(".settings-dropdown-tour").dropdown('show');
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".settings-dropdown-tour");
                    },
                    title: "Access Your Settings",
                    content: "Visit your Dashboard Settings to update your skills, education, location, etc. Visit Notification Settings to schedule your dashboard digest - a recap of content you may have missed on your Lounge page.",
                    onPrev: function () {
                        $(".settings-dropdown-tour").dropdown('hide');
                    },
                    onNext: function() {
                        $(".settings-dropdown-tour").dropdown('hide');
                    },
                },
                {
                    placement: "bottom",
                    element: function () {
                        return $(document).find(".lounge-navbar-nav-tour");
                    },
                    title: "Explore",
                    content: "Use the links up here to search all Nurses Lounge has to offer. More jobs, degrees, articles and other content is added  every week!",
                    onPrev: function () {
                        $(".settings-dropdown-tour").dropdown('show');
                    },
                },
            ];
        }else{
            $steps = [
                {
                    placement: "bottom",
                    element: function () {
                        return $(document).find(".my-dashboard-tour");
                    },
                    title: "Let's Tour Your New Dashboard",
                    content: "We’ll quickly show you around your dashboard and Nurses Lounge features.",
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-bulletin-board-tour");
                    },
                    title: "My Bulletin Board",
                    content: "Announcements for jobs, events, hiring bonuses and other content will be shared here. Over time posts become more relevant to your skills, education and location.",
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-profile-tour");
                    },
                    title: "Resume Builder",
                    content: "Add your skills and education to preview and download a .PDF resume. ",
                    onNext: function() {
                        $(".nav-scroller-right-tour").click();
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-articles-tour");
                    },
                    title: "My Articles",
                    content: "Do you enjoy writing or sharing articles related to nursing? Add them here. Submit  articles you author or share articles you enjoy and credit the author. We’ll add them to the collection. ",
                    onPrev: function () {
                        $(".nav-scroller-left-tour").click();
                    },
                    onNext: function() {
                        $(".nav-scroller-left-tour").click();
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".nav-scroller-right-tour");
                    },
                    title: "Your Dashboard",
                    content: "Scroll through the various categories. Sit back and relax we deliver the nursing profession to you.",
                    onPrev: function () {
                        $(".nav-scroller-right-tour").click();
                    },
                    onNext: function() {
                        $(".nav-scroller-left-tour").click();
                    },
                    delay:1800
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".my-lounges-list-tour");
                    },
                    title: "Follow, Rate & Review",
                    content: "Follow organizations of your interest to prioritize their content to your bulletin board. Anonymously rate & review schools and employers to help nurses make tough career choices.",
                    onNext: function() {
                        $(".settings-dropdown-tour").dropdown('show');
                    },
                },
                {
                    placement: "right",
                    element: function () {
                        return $(document).find(".settings-dropdown-tour");
                    },
                    title: "Access Your Settings",
                    content: "Visit your Dashboard Settings to update your skills, education, location, etc. Visit Notification Settings to schedule your dashboard digest - a recap of content you may have missed on your Lounge page.",
                    onPrev: function () {
                        $(".settings-dropdown-tour").dropdown('hide');
                    },
                    onNext: function() {
                        $(".settings-dropdown-tour").dropdown('hide');
                    },
                },
                {
                    placement: "bottom",
                    element: function () {
                        return $(document).find(".lounge-navbar-nav-tour");
                    },
                    title: "Explore",
                    content: "Use the links up here to search all Nurses Lounge has to offer. More jobs, degrees, articles and other content is added  every week!",
                    onPrev: function () {
                        $(".settings-dropdown-tour").dropdown('show');
                    },
                },
            ];
        }
        var $tour = new Tour({
            framework: 'bootstrap4',
            smartPlacement: false,
            name: 'tourist',
            container: 'body',
            autoscroll: true,
            keyboard: true,
            storage: false,
            debug: false,
            backdrop: false,
            backdropContainer: 'document',
            backdropPadding: 0,
            redirect: true,
            orphan: false,
            duration: false,
            delay: false,
            basePath: '',
            showProgressBar: true,
            showProgressText: true,
            template: '' +
                '<div class="popover" role="tooltip">' +
                '   <div class="arrow"></div>' +
                '   <h3 class="popover-header"></h3>' +
                '   <div class="popover-body"></div>' +
                '   <div class="popover-navigation">' +
                '       <div class="btn-group">' +
                '           <button class="btn btn-sm btn-secondary" data-role="prev">&laquo; Prev</button>' +
                '           <button class="btn btn-sm btn-secondary" data-role="next">Next &raquo;</button>' +
                '           <button class="btn btn-sm btn-secondary" data-role="pause-resume" data-pause-text="Pause" data-resume-text="Resume">Pause</button>' +
                '       </div>' +
                '       <button class="btn btn-sm btn-secondary" data-role="end">End tour</button>' +
                '   </div>' +
                '</div>',
            onStart: function () {
                router.navigate("myDashboard/activity");
            },
            onEnd: function () {
                $(".settings-dropdown-tour").dropdown('hide');
            },
            steps: $steps
        });
        $tour.restart();
    },
};
